export default __webpack_public_path__ + "static/media/warning--loose-road-surface--g4.5d211f2c.png";